import React, { Component } from "react";
import { ColGrid, RowGrid } from "js/react/components/LayoutGrid";
import Button from "js/react/components/Button2";
import {
    Section,
    UIPane,
    UIPaneContents,
    UIPaneHeader
} from "js/react/components/UiComponents";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import ExportDialog from "js/react/views/PresentationSettings/dialogs/ExportDialog";

export default class ExportPane extends Component {
    export() {
        ShowDialog(ExportDialog, { presentation: this.props.presentation });
    }

    printToPDF() {
        this.props.presentation.printToPDF();
    }

    render() {
        return (
            <UIPane className="export-pane">
                <UIPaneHeader>Export Presentation</UIPaneHeader>
                <UIPaneContents>
                    <Section title="Export Presentation">
                        <RowGrid gap={20}>
                            <ColGrid>
                                <Button
                                    icon="cloud_download"
                                    onClick={() => this.export()}
                                    label="Export Presentation..."
                                />
                            </ColGrid>
                            <h3>
                                <strong>IMPORTANT:</strong> Exported
                                presentations do not support Beautiful.ai
                                animations at this time.
                            </h3>
                        </RowGrid>
                    </Section>

                    <Section title="Print Presentation">
                        <RowGrid gap={20}>
                            <ColGrid>
                                <Button
                                    icon="print"
                                    label="Print Presentation..."
                                    onClick={() => this.printToPDF()}
                                />
                            </ColGrid>
                            <h3>
                                <strong>IMPORTANT:</strong> Browser pop-up
                                blockers may prevent Print Presentation from
                                working. Please set your browser to allow popups
                                from www.beautiful.ai or click on the popup
                                warning in your toolbar once Preparing to Print
                                is completed.
                            </h3>
                        </RowGrid>
                    </Section>
                </UIPaneContents>
            </UIPane>
        );
    }
}
